import { Component, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';
import { Notification } from '../../beans/Notification';
import { OnDestroy } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { EditCaseComponent } from '../../cases/edit-case/edit-case.component';

@Component({
	selector: 'app-notification-bell',
	templateUrl: './notification-bell.component.html',
	styleUrls: ['./notification-bell.component.scss']
})
export class NotificationBellComponent implements OnInit {

	@ViewChild('editCase') editCase!: EditCaseComponent;


	notifications: Notification[] = [];
	private refreshSub?: Subscription;
	unread = 0;
	open = false;

	// ⏱️ за да разграничим click / dblclick
	private clickTimeout: any;

	constructor(
		private service: NotificationService,
		private router: Router,
		private elementRef: ElementRef
	) { }

	ngOnInit() {
		// 🔥 първоначално зареждане
		this.refresh();


		// 🔁 авто-refresh на 2 минути
		this.refreshSub = interval(120_000) // 2 минути
			.subscribe(data => {
				this.refresh();
			});
	}
	ngOnDestroy(): void {
		// ❗ МНОГО ВАЖНО
		if (this.refreshSub) {
			this.refreshSub.unsubscribe();
		}
	}

	refresh() {
		console.log('refreshing notifications....');
		this.service.loadHeader().subscribe(n => this.notifications = n);
		this.service.unreadCount().subscribe(c => this.unread = c);
	}

	toggle() {
		this.open = !this.open;
	}

	// 🟡 SINGLE CLICK → mark as read
	onSingleClick(n: Notification) {
		clearTimeout(this.clickTimeout);

		this.clickTimeout = setTimeout(() => {
			if (!n.read) {
				this.service.markRead(n.id).subscribe(() => {
					n.read = true;
					this.unread = Math.max(0, this.unread - 1);
				});
			}
		}, 200); // ако до 200ms няма dblclick → счита се за single
	}

	// 🔥 DOUBLE CLICK → open case
	onDoubleClick(n: Notification) {
		clearTimeout(this.clickTimeout);

		this.open = false; // затваряме dropdown-а

		if (!n.lawsuiteId) {
			console.warn('Notification without lawsuiteId', n);
			return;
		}

		

		// 2️⃣ отваряме делото (както при задачите)
		this.editCase.editCaseFromNotification(n.lawsuiteId);
	}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent) {
		if (!this.open) return;

		const clickedInside = this.elementRef.nativeElement.contains(event.target);
		if (!clickedInside) {
			this.open = false;
		}
	}
}
